/**
 * Singapura — 챗봇 주소 입력(📍 → Enter Address) 결과를 문서용 한 줄 주소로.
 *   SG 로컬 입력은 line(블록·거리·건물·#층-호) + postcode + country('Singapore') 를 따로 보낸다
 *   → "…, #21-99, Singapore 059818" 처럼 우편번호까지 붙인다(자동채움 buildAddress 와 같은 형식).
 *   해외 입력은 line 만 온다.
 */
export interface AppliedAddress {
  line?: string; line1?: string; line2?: string; line3?: string;
  town?: string; state?: string; postcode?: string; country?: string;
}

const st = (v: unknown) => String(v ?? '').trim();

export function formatAppliedAddress(a: AppliedAddress | null | undefined): string {
  if (!a) return '';
  const head = st(a.line) || [a.line1, a.line2, a.line3].map(st).filter(Boolean).join(', ');
  const pc = st(a.postcode); const town = st(a.town); const state = st(a.state); const country = st(a.country);
  const tail = town || state
    ? [[pc, town].filter(Boolean).join(' '), state, country].filter(Boolean).join(', ')
    : [country, pc].filter(Boolean).join(' ');
  if (!tail || (pc && head.includes(pc))) return head;
  return [head, tail].filter(Boolean).join(', ');
}
